import { ApiClient } from '@wix/gg-components';
import { HttpClient } from '@wix/http-client';
import { useAppStore } from '../store/appStore';

export const apiClient = new ApiClient({
  baseURL: typeof window !== 'undefined' ? window.__BASEURL__ || '' : '',
});

export const ambassadorClient = new HttpClient({
  createHeaders: () => {
    const msId = useAppStore.getState().msId;
    const headers: Record<string, string> = {};
    if (msId) {
      headers['x-wix-msid'] = msId;
    }
    return headers;
  },
});
